export const API_PATHS = {
  auth: '/auth-application',
  database: (appId?: string) =>
    `/applications/${appId ?? ':appId'}/face-dbs/cluster`,
  setting: (appId?: string, dbId?: string) =>
    `/applications/${appId ?? ':appId'}/face-dbs/cluster/${
      dbId ?? ':dbId'
    }/roles`,
  visit: '/face-ids/visits',
  face_db: '/face-db',
  get_reference_image: (id?: string) =>
    `/face-ids/reference/${id ?? ':id'}/image`,
  get_face_image: (id?: string) => `/face-ids/${id ?? ':id'}/image`,
};
